import React from 'react';

import { Tag, TagLabel, HStack, Portal, MenuList } from '@chakra-ui/react';
import { themeColors } from 'themes/clients/baseTheme';

import { Menu, MenuButton, MenuItem } from 'uiToolkitV1/MenuV2';
import { GenericControl, ReadOnlyGenericControl } from 'uiToolkitV1/SelectV2/GenericControl';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const ItemChipRenderer = ({ label = 'NA' }) => (
  <Tag
    size="md"
    borderRadius="6px"
    m="4px !important"
    variant="solid"
    backgroundColor={themeColors.neutral.F2F2F2}
    color={themeColors.text.g1}
    fontWeight={400}
    fontSize="14px"
    minWidth="max-content"
  >
    <TagLabel>{label}</TagLabel>
  </Tag>
);

const MultiSelect = ({
  onSelect,
  menuItems,
  selectedItems = [],
  // permittedValues = [],
  valueKey = 'value',
  labelKey = 'label',
  renderMenuItem = (menuItem) => <TextBodyMedium> {menuItem?.[labelKey]} </TextBodyMedium>,
  renderControlItem = renderMenuItem,
  renderAs = GenericControl,
  isReadOnly = false /* isReadOnly takes priority over renderAs */,
  menuButtonProps = {},
  menuListProps = {},
  ...props
}) => {
  const as = isReadOnly ? ReadOnlyGenericControl : renderAs;

  const checkMenuSelected = (menuItem) =>
    Boolean(selectedItems.find((curItem) => curItem?.[valueKey] === menuItem?.[valueKey]));

  // const checkMenuItemDisabled = (menuItem) => {
  //   // checking whether the menuItem.value is in permitttedValues
  //   return !Boolean(permittedValues.length && !permittedValues.includes(menuItem?.[valueKey]));
  // };

  const handleTempClick = (menuItem) => {
    const isMenuSelected = checkMenuSelected(menuItem);
    if (isMenuSelected) {
      onSelect(selectedItems.filter((curItem) => curItem?.[valueKey] !== menuItem?.[valueKey]));
    } else {
      onSelect([...selectedItems, menuItem]);
    }
  };

  return (
    <Menu matchWidth {...props}>
      <MenuButton as={as} {...menuButtonProps} h="auto !important">
        <HStack overflow="auto" pointerEvents="all" wrap="wrap" maxW="100%">
          {selectedItems.length === 0 && <ItemChipRenderer label="None" />}
          {selectedItems.map((option) => {
            // if selectedItems > 1 then not showing NONE chip
            if (selectedItems.length > 1 && option?.[valueKey] === 'NONE') return null;
            return <ItemChipRenderer label={option?.[labelKey]} />;
          })}
        </HStack>
      </MenuButton>
      <Portal>
        <MenuList
          sx={{
            div: {
              padding: '0px !important',
              // not last div
              '&:not(:last-child)': {
                marginBottom: '4px !important',
              },
            },
          }}
          p="8px"
          overflow="auto"
          maxHeight="50vh"
          zIndex="tooltip"
          {...menuListProps}
        >
          {menuItems.map((menuItem) => {
            const isDisabled = menuItem?.isDisabled;
            const isHidden = menuItem?.isHidden;
            if (isHidden) return null;
            return (
              <MenuItem
                key={menuItem?.[valueKey]}
                isSelected={checkMenuSelected(menuItem)}
                onClick={() => handleTempClick(menuItem)}
                isDisabled={isDisabled}
                className={isDisabled ? ' disabled-multi-select' : ''}
              >
                {renderMenuItem(menuItem, labelKey)}{' '}
              </MenuItem>
            );
          })}
        </MenuList>
      </Portal>
    </Menu>
  );
};

export default MultiSelect;
